import { User } from "./types";

const transformToBoolean = (value: any): boolean => {
  if (value === undefined || value === null) {
    return true;
  }

  return value === true || value === 1 || value === "1";
};

export const transformToUser = (res: any): User => {
  return {
    id: res.id,
    first_name: res.first_name,
    last_name: res.last_name,
    email: res.email,
    username: res.username || "",
    password: "",
    password_confirmation: "",
    user_type: res.user_type || "user",
    active: transformToBoolean(res.active),
    groups: res.groups || res.user_groups || [],
  };
};

export const transformToUserRequest = (user: User): any => {
  const request: any = {
    first_name: user.first_name,
    last_name: user.last_name,
    email: user.email,
    username: user.username,
    user_type: user.user_type,
    active: user.active,
    group_ids: (user.groups || []).map((group) => group.id),
  };

  if (user.password) {
    request.password = user.password;
  }

  return request;
};
